export default "__VITE_ASSET__D2lYFT6i__"